import { cn } from "@theprelude/core";

export const ShieldFile: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.33333 6.00004V2.66671H3.33333V13.3334H7.37067C7.58933 13.6114 7.85333 13.8567 8.15733 14.0567L9.084 14.6667H2.662C2.48654 14.6667 2.31826 14.5971 2.19413 14.473C2.07 14.349 2.00018 14.1808 2 14.0054V1.99471C2 1.63671 2.29933 1.33337 2.668 1.33337H9.998L14 5.33337V6.00004H9.33333ZM8 7.33337H14V11.2994C14 11.9594 13.666 12.5767 13.1093 12.9427L11 14.332L8.89067 12.9427C8.61775 12.7641 8.39348 12.5205 8.23802 12.2338C8.08256 11.9471 8.00077 11.6262 8 11.3V7.33337ZM9.33333 11.2994C9.33333 11.51 9.44133 11.7087 9.624 11.8294L11 12.736L12.376 11.8294C12.4646 11.7721 12.5376 11.6936 12.5883 11.6011C12.6391 11.5086 12.666 11.4049 12.6667 11.2994V8.66671H9.33333V11.2994Z" />
  </svg>
);
